import { render, staticRenderFns } from "./MatchTeamList.vue?vue&type=template&id=5fd21ac8&scoped=true&"
import script from "./MatchTeamList.vue?vue&type=script&lang=js&"
export * from "./MatchTeamList.vue?vue&type=script&lang=js&"
import style0 from "./MatchTeamList.vue?vue&type=style&index=0&id=5fd21ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd21ac8",
  null
  
)

export default component.exports